import { Styles } from '@types'
import { Input } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { ReceiptSearch } from 'gadjet-v2-types/dist/type/search'
import { RangeValue } from 'rc-picker/lib/interface'
import { useMemo } from 'react'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import SearchBox from '@components/molecules/SearchBox'
import SearchItem from '@components/molecules/SearchItem'

type Props = {
  search: ReceiptSearch
  onChangeSearch: (search: Partial<ReceiptSearch>) => void
  onSearch: () => void
}

export default function BranchReceiptSearchBox({ search, onChangeSearch, onSearch }: Props): JSX.Element {
  const rangeValue = useMemo((): [Dayjs, Dayjs] => {
    const [start, end] = search.requestDatetime
    return [dayjs(start), dayjs(end)]
  }, [search])

  const onChangeDateRange = (_value: RangeValue<Dayjs>) => {
    const start = _value?.[0]?.format('YYYY-MM-DD') || search.requestDatetime[0]
    const end = _value?.[1]?.format('YYYY-MM-DD') || search.requestDatetime[1]
    onChangeSearch({ requestDatetime: [start, end] })
  }

  const onChangeQuery = (e: React.ChangeEvent<HTMLInputElement>) => onChangeSearch({ query: e.target.value })

  return (
    <SearchBox onSearch={onSearch}>
      <SearchItem label="날짜" span={6} helpText="해당 기간동안 발행된 증빙을 검색합니다">
        <LocalDatePicker.RangePicker
          ranges={{
            '이번 달': [dayjs().startOf('month'), dayjs().endOf('month')],
            '지난 달': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
          }}
          size="large"
          style={styles.datePicker}
          value={rangeValue}
          onChange={onChangeDateRange}
        />
      </SearchItem>
      <SearchItem label="검색어" span={6}>
        <Input size="large" placeholder="검색어를 입력하세요." value={search.query} onChange={onChangeQuery} />
      </SearchItem>
    </SearchBox>
  )
}

const styles: Styles = {
  datePicker: { width: '100%' },
}
